"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper.default;
  }
});

var _Paper = _interopRequireDefault(require("./Paper"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/Paper/index.js
 ** module id = 74
 ** module chunks = 0
 **/